import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c70e3d56")

_pushScopeId("data-v-c70e3d56")
const _hoisted_1 = { class: "p-ml-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Tree = _resolveComponent("Tree")

  return (_openBlock(), _createBlock(_component_Tree, {
    id: "folders-tree",
    value: _ctx.nodes,
    selectionMode: "single",
    selectionKeys: _ctx.selectedFolderKey,
    "onUpdate:selectionKeys": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedFolderKey = $event)),
    onNodeSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSelectedFolder($event))),
    onNodeUnselect: _ctx.removeSelectedFolder,
    onNodeExpand: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setOpenFolderIcon($event))),
    onNodeCollapse: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setClosedFolderIcon($event)))
  }, {
    default: _withId((slotProps) => [
      _createVNode("div", {
        class: "p-d-flex p-flex-row p-ai-center",
        onMouseover: ($event: any) => (_ctx.buttonsVisible[slotProps.node.id] = true),
        onMouseleave: ($event: any) => (_ctx.buttonsVisible[slotProps.node.id] = false)
      }, [
        _createVNode("span", null, _toDisplayString(slotProps.node.label), 1),
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode(_component_Button, {
            icon: "fa fa-plus",
            class: "p-button-link p-button-sm p-p-0",
            onClick: _withModifiers(($event: any) => (_ctx.createFolder(slotProps.node)), ["stop"])
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            icon: "far fa-trash-alt",
            class: "p-button-link p-button-sm p-p-0",
            onClick: _withModifiers(($event: any) => (_ctx.deleteFolderConfirm(slotProps.node)), ["stop"])
          }, null, 8, ["onClick"])
        ], 512), [
          [_vShow, _ctx.mode === 'select' && _ctx.buttonsVisible[slotProps.node.id]]
        ])
      ], 40, ["onMouseover", "onMouseleave"])
    ]),
    _: 1
  }, 8, ["value", "selectionKeys", "onNodeUnselect"]))
})